import styled, { css } from 'styled-components';
import { colors, spacing } from '../../../styles/theme';

interface Props {
  type?: 'default' | 'error' | 'success';
  paddingSize?: 'small' | 'regular' | 'large';
  marginBottom?: number;
}

export default styled.div<Props>`
  padding: ${spacing('2')};
  background-color: ${colors('black.08')};
  border: 1px solid ${colors('default.base')};
  border-radius: 10px;

  ${({ type }: Props) =>
    type === 'error' &&
    css`
      color: #d22;
      background-color: #fee;
      border-color: #d22;
    `}

  ${({ type }: Props) =>
    type === 'success' &&
    css`
      color: #393;
      background-color: #dfd;
      border-color: #393;
    `}

  ${({ paddingSize }: Props) =>
    paddingSize === 'small' &&
    css`
      padding: ${spacing('1')};
    `}

${({ paddingSize }: Props) =>
    paddingSize === 'large' &&
    css`
      padding: ${spacing('4')};
    `}

${({ marginBottom }: Props) =>
    css`
      margin-bottom: ${marginBottom}px;
    `}
`;
